import React from "react";
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const Comments = ({
  module,
  onChange,
  onSubmit,
  disabled,
  comments,
  comment,
  ...props
}) => {


  const handleChange = (event) => {
  	onChange(event.target.value)
  }

  const handleCommentSubmit = () => {
  	onSubmit()
  }

  const useStyles = makeStyles((theme) => ({
	  root: {
	    flexGrow: 1,
	  },
	  comment_title: {
	  	fontSize:'0.80rem'
	  },
	  comment_message:{
	  	fontSize: '0.75rem'
	  },
	  button:{
	  	fontSize: '0.80rem'
	  },
	  paper: {
	    padding: theme.spacing(2),
	  },
	}));

	const classes = useStyles();

	const formatDate = date => {
		var d = new Date(date),
		    month = '' + (d.getMonth() + 1),
		    day = '' + d.getDate(),
		    year = d.getFullYear();

		if (month.length < 2) 
		    month = '0' + month;
		if (day.length < 2) 
		    day = '0' + day;

		return [year, month, day].join('-');
	}

	return (
		<div className={classes.root}>
			<Typography variant="h6" className="mt-2"	>
				Comentarios
			</Typography>
			<Paper className={classes.paper} >
				<Grid container spacing={1} >
					{(comments.map((val, idx)=>{
						return (
							<Grid item xs={12}>
								<Typography  className={classes.comment_title} gutterBottom>
					              {val.commentator.name} - {formatDate(val.created_at)} 
					            </Typography>
					            <Typography className={classes.comment_message} gutterBottom>
					            	{val.comment}
					            </Typography>
							</Grid>

						)
					}))}
					<Grid item xs={12}>
						<TextField 
							value={comment}
							disabled={disabled}
							onChange={handleChange}
							id="comment"
							fullWidth
							placeholder="Ingrese un comentario"
					        InputLabelProps={{
					          shrink: true
					        }}
					        inputProps={{style:{fontSize: '0.75rem'}}} 					
						/>
					</Grid>
					<Grid item xs={12}>
						<Button disabled={disabled} variant="contained" color="primary" onClick={(e)=>handleCommentSubmit(e, comment)}>
						  Agregar comentario
						</Button>
					</Grid>
				</Grid>
			</Paper>
		</div>
	)
}

Comments.defaultProps = {
  disabled: false,
  comments:[]  
}

export default Comments;